// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { Button as KButton } from '@progress/kendo-vue-buttons';
import { kendoThemeMaps } from '@progress/kendo-vue-common';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { messages, pagerSmallPageSelectorAriaLabel } from '../messages/main';
/**
 * @hidden
 */
var PagerNumericButtonsVue2 = {
  name: 'KendoNumericButtons',
  props: {
    buttonCount: Number,
    totalPages: Number,
    currentPage: Number,
    size: String,
    responsiveSize: String
  },
  inject: {
    kendoLocalizationService: {
      default: null
    }
  },
  computed: {
    start: {
      get: function get() {
        var page = this.$props.currentPage;
        var buttonCount = this.$props.buttonCount;
        if (page > buttonCount) {
          var reminder = page % buttonCount;
          return reminder === 0 ? page - buttonCount + 1 : page - reminder + 1;
        }
        return 1;
      }
    },
    end: {
      get: function get() {
        return Math.min(this.start + this.$props.buttonCount - 1, this.$props.totalPages);
      }
    },
    dropdownClass: function dropdownClass() {
      var _a;
      var size = this.$props.size;
      return _a = {
        'k-picker': true,
        'k-dropdown-list': true,
        'k-dropdown': true,
        'k-rounded-md': true,
        'k-picker-solid': true
      }, _a["k-picker-".concat(kendoThemeMaps.sizeMap[size] || size)] = size, _a;
    }
  },
  methods: {
    click: function click(e, page) {
      e.preventDefault();
      this.$emit('pagechange', page, e);
    },
    ddlChange: function ddlChange(event) {
      this.$emit('pagechange', parseInt(event.target.value, 10), event);
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;
    var h = gh || createElement;
    var localizationService = provideLocalizationService(this);
    var pagerSmallPageSelectoLabel = this.$props.messagesMap ? this.$props.messagesMap(pagerSmallPageSelectorAriaLabel) : {
      messageKey: pagerSmallPageSelectorAriaLabel,
      defaultMessage: messages[pagerSmallPageSelectorAriaLabel]
    };
    var prevDots = this.start > 1 &&
    // @ts-ignore function children
    h(KButton, {
      fillMode: 'flat',
      attrs: this.v3 ? undefined : {
        fillMode: 'flat',
        themeColor: 'primary',
        size: this.$props.size,
        rounded: null
      },
      themeColor: 'primary',
      size: this.$props.size,
      rounded: null,
      onClick: function onClick(e) {
        return _this.click(e, _this.start - 1);
      },
      on: this.v3 ? undefined : {
        "click": function onClick(e) {
          return _this.click(e, _this.start - 1);
        }
      }
    }, this.v3 ? function () {
      return ["..."];
    } : ["..."]);
    var postDots = this.end < this.$props.totalPages &&
    // @ts-ignore function children
    h(KButton, {
      fillMode: 'flat',
      attrs: this.v3 ? undefined : {
        fillMode: 'flat',
        themeColor: 'primary',
        size: this.$props.size,
        rounded: null
      },
      themeColor: 'primary',
      size: this.$props.size,
      rounded: null,
      onClick: function onClick(e) {
        return _this.click(e, _this.end + 1);
      },
      on: this.v3 ? undefined : {
        "click": function onClick(e) {
          return _this.click(e, _this.end + 1);
        }
      }
    }, this.v3 ? function () {
      return ["..."];
    } : ["..."]);
    var buttons = [];
    for (var idx = this.start; idx <= this.end; idx++) {
      buttons.push(idx);
    }
    var numerics = buttons.map(function (page) {
      var _this = this;
      return (
        // @ts-ignore function children
        h(KButton, {
          key: page,
          "class": 'k-link',
          onClick: function onClick(e) {
            return _this.click(e, page);
          },
          on: this.v3 ? undefined : {
            "click": function onClick(e) {
              return _this.click(e, page);
            }
          },
          selected: this.$props.currentPage === page,
          attrs: this.v3 ? undefined : {
            selected: this.$props.currentPage === page,
            fillMode: 'flat',
            themeColor: 'primary',
            size: this.$props.size,
            rounded: null,
            role: "button",
            title: 'Page ' + page,
            "aria-current": this.$props.currentPage === page ? true : undefined
          },
          fillMode: 'flat',
          themeColor: 'primary',
          size: this.$props.size,
          rounded: null,
          role: "button",
          title: 'Page ' + page,
          "aria-current": this.$props.currentPage === page ? true : undefined
        }, this.v3 ? function () {
          return [page];
        } : [page])
      );
    }, this);
    var dropdown = function dropdown(currentButtons) {
      return h("select", {
        style: {
          width: '5em',
          margin: '0px 1em',
          display: this.$props.responsiveSize === 'small' ? 'inline-flex' : 'none'
        },
        "class": this.dropdownClass,
        ariaLabel: localizationService.toLanguageString(pagerSmallPageSelectoLabel.messageKey, pagerSmallPageSelectoLabel.defaultMessage),
        attrs: this.v3 ? undefined : {
          ariaLabel: localizationService.toLanguageString(pagerSmallPageSelectoLabel.messageKey, pagerSmallPageSelectoLabel.defaultMessage)
        },
        onChange: this.ddlChange,
        on: this.v3 ? undefined : {
          "change": this.ddlChange
        }
      }, [currentButtons.map(function (cb) {
        return h("option", {
          value: this.v3 ? cb : null,
          domProps: this.v3 ? undefined : {
            "value": cb,
            "selected": cb === this.$props.currentPage
          },
          selected: this.v3 ? cb === this.$props.currentPage : null
        }, [cb]);
      }, this)]);
    };
    return h("div", {
      "class": "k-pager-numbers-wrap"
    }, [h("div", {
      "class": "k-pager-numbers",
      style: {
        display: this.$props.responsiveSize !== 'small' ? '' : 'none'
      }
    }, [prevDots, numerics, postDots]), dropdown.call(this, buttons)]);
  }
};
/**
 * @hidden
 */
var PagerNumericButtons = PagerNumericButtonsVue2;
export { PagerNumericButtons, PagerNumericButtonsVue2 };